import { useSelector } from 'react-redux';

import { searchSelectors } from 'wanderu-ducks-search';
import { tripSelectors } from 'wanderu-ducks-trips';
import type { RootState } from 'wanderu-shellapp';

import type { match as Match } from 'react-router';

export const useArriveTripSelector = (tripId: string) => {
    const arriveTripSelector = (state: RootState) => tripSelectors
        .selectTripArriveData(state, tripId);

    return useSelector(arriveTripSelector);
};

export const useSearchParamsSelector = ({
    location,
    match,
}: {
    location: Location,
    match: Match
}) => {
    const searchParamsSelector = (state: RootState) => searchSelectors
        .selectSearchParams(state, { location, match });

    return useSelector(searchParamsSelector);
};
